import React from 'react';
import './Life.css';
import classImage from '../class.jpeg';
import icon4 from '../icon4.png';
import icon5 from '../icon5.png';
import icon6 from '../icon6.png';
import icon7 from '../icon7.png';

const Life = () => {
  const lifeAspects = [
    {
      id: 1,
      icon: icon4,
      title: "Early Morning Discipline",
      description: "Brahma Muhurta prayers and daily Vedic chanting."
    },
    {
      id: 2,
      icon: icon5,
      title: "Structured Learning",
      description: "Regular classes, chanting practice, and scriptural studies."
    },
    {
      id: 3,
      icon: icon6,
      title: "Practical Training",
      description: "Hands-on experience in rituals, Samskaras, and Homams."
    },
    {
      id: 4,
      icon: icon7,
      title: "Seva & Values",
      description: "Service, humility, respect, and moral discipline."
    }
  ];

  return (
    <section className="life-section">
      <div className="container">
        <div className="life-header">
          <div className="life-line"></div>
          <h2 className="life-title">Life at Sri Veda Gurukulam</h2>
        </div>
        
        <div className="life-content">
          <div className="life-text">
            <div className="life-description">
              <p>
                Life at Sri Veda Gurukulam follows a disciplined and 
                spiritual routine rooted in traditional values. Students live a 
                simple life focused on learning, practice, devotion, and 
                service.
              </p>
            </div>
            
            <div className="life-aspects">
              {lifeAspects.map((aspect) => (
                <div key={aspect.id} className="life-aspect">
                  <div className="aspect-icon">
                    <img src={aspect.icon} alt={aspect.title} />
                  </div>
                  <div className="aspect-content">
                    <h4 className="aspect-title">{aspect.title}</h4>
                    <p className="aspect-description">{aspect.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="life-image">
            <div className="image-container">
              <img src={classImage} alt="Life at Gurukulam" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Life;